import React, { useState, useEffect } from 'react'
import { Button } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import Select from '../../dpe-usco/components/Select/Select'
import TypeAhead from '../../dpe-usco/components/TypeAhead/TypeAhead'
import { getUserRoles, inviteUser, searchCompanies } from '../../services/apiHelper'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

const LinkCompany = props => {

  const [activeRole, setActiveRole] = useState()
  const [existingUsers, setExistingUsers] = useState()
  const [rolesData, setRolesData] = useState()
  const [roleOptions, setRoleOptions] = useState([])
  const [roleId, setRoleID] = useState()
  const [showRequired, setShowRequired] = useState(false)
  const [selectedFromSearch, setSelectedFromSearch] = useState()
  const [stopSearch, setStopSearch] = useState(false)
  const { register, errors, clearError, handleSubmit, reset, setValue, watch } = useForm({})
  const { user_id } = useParams() || {}

  const watchCompanyName = watch('company_name', '')

  useEffect(() => {
    if (watchCompanyName.length > 2 && !stopSearch) {
      searchCompanies(watchCompanyName).then(res => {
        setExistingUsers(res)
      })
      setStopSearch(true)
    } 
  }, [watchCompanyName, stopSearch])

  useEffect(() => {
    const initData = () => {
      getUserRoles().then(res => {
        const externalRoles = res.filter(role => role.role_type === 'external')
        setRolesData(externalRoles)
      })
    }
    initData()
  }, [setRolesData])

  useEffect(() => {
    if (rolesData) {
      const roleNames = rolesData.map(role => {
        return role.role_name
      })
      setRoleOptions(roleNames)
    }
  }, [rolesData])

  useEffect(() => {
    if (rolesData && activeRole) {
      const matchedRoleId = rolesData.filter(role => activeRole === role.role_name)
        .map(role => {
          return role.role_id
        })
      setRoleID(matchedRoleId)
    }
  }, [activeRole, rolesData])

  const roleSelection = value => {
    setActiveRole(value)
  }

  const onSubmit = () => {
    if (activeRole && roleId) {
      let role_id = roleId[0]
      let company_id = selectedFromSearch
      inviteUser({ role_id, company_id, user_id })
      if (props.onSuccess) props.onSuccess()
      props.handleCreate()
      reset()
      clearError()
    } else {
      setShowRequired(true)
    }
  }

  const handleCancelModal = () => {
    reset()
    setActiveRole(null)
    setShowRequired(false)
    clearError()
    props.handleCancel()
  }

  const _nameCallback = val => {
    setValue('company_name', val.name)
    setSelectedFromSearch(val.company_id)
  } 
    
  return (
    <div>
      <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
        <div className='df jcsb'>
          <p className='fz16 ml16 fw600'>Link Company</p>
          <button className='bdnone m0 bgc-t' onClick={handleCancelModal}>
            <img src={clear} alt='cancel button' />
          </button>
        </div>
        <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
        <div className='p16 df jcsb fxdrr fxww w100%'>
          <div className='w45% tal'>
            <form onSubmit={handleSubmit(onSubmit)}>
              <label className='fz13'>Company</label>
              <TypeAhead className='fz15 lh1.3' id='company_name' name='company_name' placeholder='Search company'
                ref={register({ required: true })}
                item_id='company_name'
                item_value='name'
                item_value_additional='company_city_state_zip'
                data={existingUsers}
                callback={_nameCallback}
                onChange={() => setStopSearch(false)}
              />
              <div className='c-red tal fz15 mt5'>
                {errors.company_name && errors.company_name.type === 'required' && 'Please provide company name'}
              </div>
            </form>
          </div>
          <div className='w45%'>
            <label className='fz13'>Role</label>
            <div className='fz15 '>
              <Select placeholder={'Role'} handleSelection={(roleSelection)} options={roleOptions}></Select>
            </div>
            <div className='c-red tal fz15 mt5'>
              {showRequired
                ?
                'Please select a role'
                :
                null}
            </div>
          </div>
        </div> 
        <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
        <div className='df jcfe posr'>
          <Button type='default' text='Cancel' clickHandler={handleCancelModal}/>
          <Button type='success' text='Link' clickHandler={handleSubmit(onSubmit)} customClassName='mr15 ml10'/>
        </div>
      </div>
    </div>
  )
}

export default LinkCompany